module.exports = __webpack_public_path__ + "static/media/drop-down.1dad5369.svg";